import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-330bca5e"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "search-wrapper"
};
const _hoisted_2 = ["innerHTML"];
const _hoisted_3 = ["innerHTML"];
const _hoisted_4 = {
  class: "product-name"
};
const _hoisted_5 = ["href"];
const _hoisted_6 = {
  class: "content"
};
const _hoisted_7 = {
  class: "name"
};
const _hoisted_8 = {
  class: "ltv-breakdown"
};
const _hoisted_9 = {
  class: "tooltip-title"
};
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Average LTV", -1));
const _hoisted_11 = {
  class: "tooltip-content"
};
const _hoisted_12 = {
  class: "composite-bar"
};
const _hoisted_13 = {
  class: "ltv-composite-bar"
};
const _hoisted_14 = {
  class: "details"
};
const _hoisted_15 = {
  class: "value"
};
const _hoisted_16 = {
  class: "value-text"
};
const _hoisted_17 = {
  class: "breakdown"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_app_input = _resolveComponent("app-input");
  const _component_wrap_with_popover = _resolveComponent("wrap-with-popover");
  const _component_AppIcon = _resolveComponent("AppIcon");
  const _component_flex_row = _resolveComponent("flex-row");
  const _component_hug_value = _resolveComponent("hug-value");
  const _component_hoverable_image = _resolveComponent("hoverable-image");
  const _component_wrap_with_copy = _resolveComponent("wrap-with-copy");
  const _component_value_element = _resolveComponent("value-element");
  const _component_bar_with_value = _resolveComponent("bar-with-value");
  const _component_overlap_bar_value = _resolveComponent("overlap-bar-value");
  const _component_currency_value = _resolveComponent("currency-value");
  const _component_LTVCompositeBar = _resolveComponent("LTVCompositeBar");
  const _component_b_table_lite = _resolveComponent("b-table-lite");
  const _component_table_with_title = _resolveComponent("table-with-title");
  const _component_app_pagination = _resolveComponent("app-pagination");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_table_with_title, {
    class: "ltv-per-asin-table",
    onDownload: $options.downloadLTVPerAsinCSV,
    onGoogleSheetDownload: $options.downloadLTVPerAsinGoogleSheet,
    onCopy: $options.copyLTVPerAsinCSV,
    fields: $options.computedFields,
    loading: $props.loading,
    customStyles: {
      height: 'fit-content'
    },
    title: "Per ASIN"
  }, {
    "period-selector": _withCtx(() => [_renderSlot(_ctx.$slots, "period-selector", {}, undefined, true)]),
    default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(_component_app_input, {
      class: "ltv-per-asin-input",
      modelValue: $data.search,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.search = $event),
      placeholder: "Search product name/ASIN...",
      v2: "",
      version: "search",
      debounce: "1000",
      minLength: "3",
      onChange: $options.searchItem
    }, null, 8, ["modelValue", "onChange"])]), _createVNode(_component_b_table_lite, {
      class: "lite-table lite-table-hoverable period-table ltv-table",
      fields: $options.computedFields,
      bordered: "",
      responsive: "",
      fixed: "",
      items: $options.items,
      "sticky-header": true,
      tbodyTrClass: item => _ctx.handleRowClass(item, $options.items),
      "no-border-collapse": "",
      onRowClicked: $options.handleRowClick
    }, {
      "head()": _withCtx(col => [_createVNode(_component_flex_row, {
        id: `ltv-per-asin-table-${col?.column}`,
        styles: {
          justifyContent: col.field.justify,
          ...col.field.thStyle,
          'line-height': '130%'
        },
        onClick: $event => $options.onSort(col.field)
      }, {
        default: _withCtx(() => [_createVNode(_component_wrap_with_popover, {
          target: `ltv-per-asin-table-${col?.column}`
        }, {
          title: _withCtx(() => [_createElementVNode("div", {
            innerHTML: $options.getDescriptionBasedOnKpiKey(col?.column).title
          }, null, 8, _hoisted_2)]),
          content: _withCtx(() => [_createTextVNode(_toDisplayString($options.getDescriptionBasedOnKpiKey(col?.column).detail), 1)]),
          default: _withCtx(() => [_createElementVNode("div", {
            innerHTML: col?.column === 'period_agg' ? $options.getPeriodColumnTitle : col?.label,
            class: "title"
          }, null, 8, _hoisted_3)]),
          _: 2
        }, 1032, ["target"]), col.field.sortable ? (_openBlock(), _createBlock(_component_AppIcon, {
          key: 0,
          icon: col.field.key === $data.sort_key ? $data.sortType < 0 ? 'ltv-per-asin-chervon-down' : 'ltv-per-asin-chervon-up' : 'ltv-per-asin-chervon-down',
          color: "#ADADAD"
        }, null, 8, ["icon"])) : _createCommentVNode("", true)]),
        _: 2
      }, 1032, ["id", "styles", "onClick"])]),
      "cell(selector)": _withCtx(row => [_createVNode(_component_hug_value, {
        loading: $props.loading
      }, {
        default: _withCtx(() => [_createVNode(_component_AppIcon, {
          icon: `zoom-${row.item.selected ? 'out' : 'in'}`,
          color: row.item.selected ? null : '#ADADAD',
          size: 16
        }, null, 8, ["icon", "color"])]),
        _: 2
      }, 1032, ["loading"])]),
      "cell(ltv_product_name)": _withCtx(row => [_createElementVNode("div", _hoisted_4, [_createElementVNode("a", {
        href: `https://${row.item.amazon_link}`,
        target: "_blank"
      }, [_createVNode(_component_hoverable_image, {
        image: row.item.main_image_link,
        active: $data.hoverableImage === row.item.amazon_link,
        onMouseenter: $event => $data.hoverableImage = row.item.amazon_link,
        onMouseleave: _cache[1] || (_cache[1] = $event => $data.hoverableImage = null)
      }, null, 8, ["image", "active", "onMouseenter"])], 8, _hoisted_5), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, _toDisplayString(row.item.product_name), 1), _createVNode(_component_wrap_with_copy, {
        class: "asin"
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(row.item.asin), 1)]),
        _: 2
      }, 1024)])])]),
      "cell(ltv_per_asin_new_customers)": _withCtx(row => [_createVNode(_component_bar_with_value, {
        value: row.item?.cohort_customers,
        min: $options.minMax?.cohort_customers?.min,
        color: "#2172E1",
        max: $options.minMax?.cohort_customers?.max,
        loading: $props.loading
      }, {
        default: _withCtx(() => [_createVNode(_component_value_element, {
          value: $options.customerNumberFormat(row.item?.cohort_customers),
          allowPrecisionModification: false,
          charCount: 5,
          tight: ""
        }, null, 8, ["value"])]),
        _: 2
      }, 1032, ["value", "min", "max", "loading"])]),
      "cell(ltv_per_asin_multiplier)": _withCtx(row => [_createVNode(_component_overlap_bar_value, {
        value: row.item?.multiplier ?? 0,
        background: $options.calculatedMultiplierColor(row.item),
        borderColor: $options.calculatedMultiplierColor(row.item),
        min: $options.minMax?.multiplier?.min,
        max: $options.minMax?.multiplier?.max,
        loading: $props.loading,
        styles: {
          padding: '6px 8px'
        },
        barStyles: {
          height: '100%'
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_value_element, {
          value: $options.multiplierFormat(row.item?.multiplier),
          allowPrecisionModification: false,
          charCount: 5,
          tight: ""
        }, null, 8, ["value"])]),
        _: 2
      }, 1032, ["value", "background", "borderColor", "min", "max", "loading"])]),
      "cell(ltv_per_asin_breakdown)": _withCtx(row => [_createElementVNode("div", _hoisted_8, [_createVNode(_component_wrap_with_popover, {
        "custom-class": "ltv-breakdown-popover"
      }, {
        title: _withCtx(() => [_createElementVNode("div", _hoisted_9, [_hoisted_10, _createVNode(_component_currency_value, {
          value: row.item?.total_value,
          precision: "2"
        }, null, 8, ["value"])])]),
        content: _withCtx(() => [_createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_createVNode(_component_LTVCompositeBar, {
          values: $options.breakdownValue(row.item),
          min: 0,
          max: row.item?.total_value
        }, null, 8, ["values", "max"])])]), _createElementVNode("div", _hoisted_14, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.breakdownValue(row.item), value => {
          return _openBlock(), _createElementBlock("div", _hoisted_15, [_createElementVNode("div", {
            class: "circle",
            style: _normalizeStyle({
              background: value.color
            })
          }, null, 4), _createElementVNode("div", _hoisted_16, _toDisplayString(value.text), 1), _createVNode(_component_currency_value, {
            value: value.value,
            precision: "2"
          }, null, 8, ["value"])]);
        }), 256))])])]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_17, [_createVNode(_component_currency_value, {
          value: row.item?.total_value,
          precision: "2"
        }, null, 8, ["value"]), _createVNode(_component_LTVCompositeBar, {
          values: $options.breakdownValue(row.item),
          min: $options.minMax?.total_value?.min,
          max: $options.minMax?.total_value?.max
        }, null, 8, ["values", "min", "max"])])]),
        _: 2
      }, 1024)])]),
      _: 1
    }, 8, ["fields", "items", "tbodyTrClass", "onRowClicked"])]),
    _: 3
  }, 8, ["onDownload", "onGoogleSheetDownload", "onCopy", "fields", "loading"]), _createVNode(_component_app_pagination, {
    class: "custom-pagination",
    page: _ctx.page,
    "onUpdate:page": [_cache[2] || (_cache[2] = $event => _ctx.page = $event), _cache[4] || (_cache[4] = $event => $options.changePage($event))],
    perPage: _ctx.perPage,
    "onUpdate:perPage": [_cache[3] || (_cache[3] = $event => _ctx.perPage = $event), _cache[5] || (_cache[5] = $event => $options.changeElements($event))],
    total: _ctx.total_rows
  }, null, 8, ["page", "perPage", "total"])], 64);
}